import { useEffect } from 'react';
import Config from '../../config-manager';
import { setPageChange, PageTypesForNative } from '../../common-utils';

export const useNativePageChange = location => {
  const currentPath = location?.pathname;
  const isMarketplacePage = currentPath === Config.get('paths.marketplace.root');
  const isProductPage = currentPath === Config.get('paths.marketplace.product');
  const isProductApplicatonPage = currentPath === Config.get('paths.product_application.root');

  useEffect(() => {
    if (isMarketplacePage) {
      setPageChange(PageTypesForNative.LANDING);
    } else if (isProductPage) {
      setPageChange(PageTypesForNative.PRODUCT);
    } else if (isProductApplicatonPage) {
      setPageChange(PageTypesForNative.PRODUCT_APPLICATION);
    } else {
      setPageChange(PageTypesForNative.PAGE_NOT_FOUND);
    }
  }, [currentPath]);
};
